export const environment = {
  production: false,
  logLevel: 'info',
  stage: 'stage',
  serverUrl: 'https://stage.pridehub.bochum-rebels.de',
  backendServerUrl: 'https://stage.pridehub.bochum-rebels.de',
  externalApiBaseUrl: '/api/external',
  mediaUrl: '/api/external/media/',
  countdownShowTime: 10,
  hCaptchaSiteKey: '8d3c9d4a-b0fc-4380-b6ba-d0f611fc9ce4'
};
